import { useSetAtom } from 'jotai';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { breadcrumbsHeaderState, useBudgetingLinkItems } from 'shared/components';

export const useBreadcrumbs = () => {
    const setBreadcrumbs = useSetAtom(breadcrumbsHeaderState);
    const { companyId } = useParams<{ companyId: string }>();
    const company = useSelector((state) => selectors.company.getCompanyById(state, companyId));
    const breadcrumbs = useBudgetingLinkItems(company);

    useEffect(() => {
        setBreadcrumbs(breadcrumbs);
    }, [breadcrumbs, setBreadcrumbs]);
};
